import React, { useState, useEffect } from 'react'
import Modal from 'components/modal'
import Field from 'components/controls/field'
import 'less/controls/switch-component.less'
import { TagInput, Intent } from "@blueprintjs/core";
import { axiosInstance } from 'network/apis'
import { Spinner } from '@blueprintjs/core'
import Button from 'components/controls/button'

const Switch = props => {

    return (
        <div className="switch-component">
            <div className="label">FILTER BY:</div>
            <Button className={`projects-toggle ${props.selectedToggle === 0? 'selected' : ''}`} onClick={() => props.onToggle(0)}>{props.firstToggle}</Button>
            <Button className={`moderators-toggle ${props.selectedToggle === 1? 'selected' : ''}`} onClick={() => props.onToggle(1)}>{props.secondToggle}</Button>
        </div>
    )
}

export default Switch
